import { Box, CircularProgress, Container, Typography } from '@mui/material';
import UserTableData from './userTableData';
import UserModal from './userModal';
import { ActionButton, PopupSnackbar } from '@/src/components';
import { useUserStoreContext } from '@/store/user.store';
import { SearchUser } from './searchUser';
import { STATE_ENUM } from '@/src/types/schema/enum/common.enum';

const UserPage = () => {
  const { snackbar, pagination, syncBamboo } = useUserStoreContext();
  const isSyncing = syncBamboo.current.state === STATE_ENUM.LOADING;

  return (
    <Container maxWidth="xl">
      <Box className="flex flex-row justify-between items-center">
        <Typography className="pt-8" variant="h1">
          Users
        </Typography>
      </Box>
      <div className="flex justify-end items-center gap-4">
        <ActionButton
          id="btn-bamboo-sync"
          variant="outlined"
          text={isSyncing ? 'Syncing...' : 'Bamboo Sync'}
          onClick={syncBamboo.requestAct}
          disabled={isSyncing}
          startIcon={isSyncing ? <CircularProgress size={20} color="inherit" /> : undefined}
        />
        <SearchUser setPaginationParams={pagination} />
      </div>
      <div className="mt-3">
        <UserTableData />
      </div>
      <UserModal />
      <PopupSnackbar open={snackbar.snackbarOpen} setOpen={snackbar.setSnackbarOpen}></PopupSnackbar>
    </Container>
  );
};

export default UserPage;
